import { $, $1 } from 'utilities/selector'
import LoadManager, { QUEUE } from './load-manager';

// Class
class DNMediaLinks {
  constructor() {
    this.mediaItems = $('[data-media]');
    if (!this.mediaItems)
      return;

    LoadManager.queue(this.init.bind(this), QUEUE.RESOURCES);
  }

  init(){
    [...this.mediaItems].forEach(this.setupLinks, this);
  }

  setupLinks(el) {
    let link = $1('[data-link]', el);
    let target = $1('[data-target]', el);
    let url = link.innerHTML.trim();

    if (url != "" && url != "Link goes here") {
      target.setAttribute('data-target', true);
      target.addEventListener('click', () => {
        window.open(url, '_blank');
      });
    }
  }
}

export default LoadManager.queue(() => new DNMediaLinks(), QUEUE.DOM);



// WEBPACK FOOTER //
// ./scripts/components/dn-media-links.js